var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bom-detail-row bom-detail-head"},_vm._l((_vm.headings),function(label,index){return _c('div',{directives:[{name:"overflow-tooltip",rawName:"v-overflow-tooltip"}],key:index},[_vm._v(" "+_vm._s(label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }